'use strict';

exports.__esModule = true;

var _wendysI18next = require('wendys-i18next');

var getSupportedLocaleFromCountry = function getSupportedLocaleFromCountry() {
    var countryCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'US';
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

    var supportedLocales = ['en' + separator + 'US', 'es' + separator + 'US', 'en' + separator + 'CA', 'fr' + separator + 'CA'];
    var localeCode = '' + (0, _wendysI18next.getLanguage)() + separator + countryCode;
    return supportedLocales.indexOf(localeCode) !== -1 ? localeCode : 'en' + separator + countryCode;
};

exports.default = getSupportedLocaleFromCountry;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/localizationHelper.js
// module id = 312
// module chunks = 0